module.exports = __webpack_public_path__ + "img/Ferreira.b91827c1.jpeg";